module.exports = __webpack_public_path__ + "media/images/airwallex-invert-3d0c6f98cdff5eda09dad7067404b3f3.png";